import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {NgbDate, NgbModal, NgbDateParserFormatter} from "@ng-bootstrap/ng-bootstrap";
import {ChartConfiguration, ChartData} from "chart.js";
import {PTPStepsService} from "../services/ptpsteps.service";
import {ActivatedRoute} from "@angular/router";
import Utils from "src/utils";
import {AuthService} from "../services/auth.service";
import {PerFormaAPIService, PTPItemTypeDto} from "src/app/services/pfapi.service";
import {NzMessageService} from "ng-zorro-antd/message";

// used for some api responses
export interface PTPResponse {
    messages: string[];
    errors: string[];
}

@Component({
    selector: "app-ptp",
    templateUrl: "./ptp.component.html",
    styleUrls: ["./ptp.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PtpComponent implements OnInit {
    constructor(
        private api: PerFormaAPIService,
        public modal: NgbModal,
        public formatter: NgbDateParserFormatter,
        private StepService: PTPStepsService,
        private route: ActivatedRoute,
        private auth: AuthService,
        private message: NzMessageService
    ) {}

    isAdmin = this.auth.isPTPAdmin ?? false;

    async ngOnInit() {
        const savedSize = localStorage.getItem("PTPPageSize") ?? 10;

        if (savedSize !== "null" && savedSize != 10) {
            this.ResultCount = parseInt(savedSize);
        }

        // get the steps
        this.Steps = await this.StepService.Steps();
        this.FilterSteps = this.Steps.filter(s => s.StepName != "Archive" && (s.StepType == 0 || s.StepType == 1)).sort(
            (a, b) => a.Order - b.Order
        );

        // check to see if they are quick opening an item
        this.route.queryParams.subscribe(prm => {
            if (prm.itemid && prm.itemtype) {
                // check if they have permission

                this.QuickOpenURL = "/ptp/Forms?itemId=" + prm.itemid + "&itemType=" + prm.itemtype;
            }
        });

        // get locations and departments
        this.getLocationsAndDepartments();
        this.getRequesters();

        this.initDashboardSearch();
    }

    // closes the page modal
    CloseModal = () => this.modal.dismissAll();

    // saves the chosen page size to local storage
    // so that the page remembers their choice
    SetResultCount = () => {
        localStorage.setItem("PTPPageSize", this.ResultCount?.toString() ?? "null");
        this.Refresh();
    };

    ModalOptions = {animation: false, backdropClass: "backdrop"};
    ModalFeatures = "height=700,width=1110,scrollbars=yes,resizable=yes,menubar=no";

    Labels5;
    Data5;
    Labels4;
    Data4;
    Labels3;
    Data3;
    Labels2;
    Data2;
    Labels;
    Data;
    Series2;

    CurrentStepObject;

    // Set vars to necessary default values.
    Loading = true;
    SelectedStep = 0;
    OrderByDashboard = "";
    OrderByPo = "";
    OrderByPr = "";
    Items = [];
    SelectedShowsCreate = false;
    CurrentSearch;
    SelectedType;
    StepName;
    Steps = [];
    CheckAllItems = false;

    // filter dropdown collections
    FilterSteps = [];
    Locations = [];
    Departments = [];
    Requesters = [];

    // dashboard filter selections (bound to the Step / Location / Requested By dropdowns)
    StepFilter = "";
    LocationFilter = "";
    RequestedByFilter = "";

    DashboardSearch: {
        Field?: any;
        Value?: any;
        Operator?: any;
        DateValue?: any;
        ShowCanceled?: boolean;
    } = {
        Field: {},
        Value: "",
        Operator: "Contains",
        ShowCanceled: false
    };

    DashboardSearchOptions = [];

    PRSearch: {
        Field?: any;
        Value?: any;
        Operator?: any;
        DateValue?: any;
        ShowCanceled?: boolean;
    } = {
        Field: {},
        Value: "",
        Operator: "Contains",
        ShowCanceled: false
    };

    PRSearchOptions = [];

    POSearch: {
        Field?: any;
        Value?: any;
        Operator?: any;
        DateValue?: any;
        ShowCanceled?: boolean;
    } = {
        Field: {},
        Value: "",
        Operator: "Contains",
        ShowCanceled: false
    };

    POSearchOptions = [];

    CancelRequest = {
        CancelNotes: "",
        CancelID: 0,
        CancelType: 0
    };

    DenyRequest = {
        DenyNotes: "",
        DenyID: 0,
        DenyType: 0
    };

    CheckRequest = {
        CheckNumber: ""
    };

    DeleteRequest = {
        VendorName: "",
        DeleteID: 0,
        DeleteType: 0
    };

    FromDate;
    ToDate;

    QuickOpenURL = "";

    get FromDateStr() {
        // return undefined (not the string "null") so the generated client omits the param and the
        // backend's nullable DateTime binds to null instead of rejecting "null" with a 400.
        return this.FromDate ? this.formatter.format(this.FromDate) : undefined;
    }

    get ToDateStr() {
        return this.ToDate ? this.formatter.format(this.ToDate) : undefined;
    }

    // Set default page.
    Page = 1;

    // Set paging options.
    DisplayOptions = [5, 10, 20, 50];

    // Set default page.
    ResultCount = 10;

    public pieChartOptions: ChartConfiguration["options"] = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: "top"
            }
        }
    };

    public pieChartData: ChartData<"pie", number[], string | string[]> = {labels: [], datasets: []};
    public barChartData2: ChartData<"bar", number[], string | string[]> = {labels: [], datasets: []};
    public pieChartData3: ChartData<"pie", number[], string | string[]> = {labels: [], datasets: []};
    public pieChartData4: ChartData<"pie", number[], string | string[]> = {labels: [], datasets: []};
    public pieChartData5: ChartData<"pie", number[], string | string[]> = {labels: [], datasets: []};

    getLocationsAndDepartments = () => {
        this.api.getApiPTPGetDeptsAndLocations().subscribe(data => {
            this.Locations = data.Locations;
            this.Departments = data.Departments;
        });
    };

    getRequesters = () => {
        this.api.getApiPTPGetRequesters().subscribe(data => {
            this.Requesters = data;
        });
    };

    initDashboardSearch = () => {
        this.api.getApiPTPGetSearchOptions({itemType: PTPItemTypeDto.NUMBER_3}).subscribe(data => {
            this.DashboardSearchOptions = data;
            this.initPoSearch();
        });
    };

    initPoSearch = () => {
        this.api.getApiPTPGetSearchOptions({itemType: PTPItemTypeDto.NUMBER_1}).subscribe(data => {
            this.POSearchOptions = data;

            // Get purchase request search options.
            this.initPrSearch();
        });
    };

    initPrSearch = () => {
        this.api.getApiPTPGetSearchOptions({itemType: PTPItemTypeDto.NUMBER_0}).subscribe(data => {
            this.PRSearchOptions = data;
            // Get steps.
            this.finishInit();
        });
    };

    finishInit = async () => {
        // Select first step.
        if (this.Steps != null && this.Steps.length > 0) {
            this.SelectStep(this.Steps[0]);
        }

        // are they coming into ptp with a quick open link?
        if (this.QuickOpenURL.length > 0) {
            const popupwin = window.open(this.QuickOpenURL, "", this.ModalFeatures);

            const popuptimer = setInterval(() => {
                if (popupwin.closed) {
                    clearInterval(popuptimer);
                    this.Refresh();
                }
            }, 500);

            try {
                popupwin.focus();
            } catch {
                alert(
                    "We tried to show you the requested item, but your browser is blocking pop-ups. Please add this site to your exception list."
                );
            }
        }
    };

    UploadInvoice = () => {
        window.location.href = "/PTP/POInvoice";
    };

    OrderDashboard = (col: string) => {
        if (this.OrderByDashboard === col + " desc") {
            this.OrderByDashboard = col + " asc";
        } else {
            this.OrderByDashboard = col + " desc";
        }
        this.Refresh();
    };

    OrderPr = (col: string) => {
        if (this.OrderByPr === col + " desc") {
            this.OrderByPr = col + " asc";
        } else {
            this.OrderByPr = col + " desc";
        }
        this.Refresh();
    };

    OrderPo = (col: string) => {
        if (this.OrderByPo === col + " desc") {
            this.OrderByPo = col + " asc";
        } else {
            this.OrderByPo = col + " desc";
        }
        this.Refresh();
    };

    DashboardSortClass = (col: string) => {
        if (this.OrderByDashboard === col + " desc") {
            return {"fa-solid fa-chevron-down": true};
        } else if (this.OrderByDashboard === col + " asc") {
            return {"fa-solid fa-chevron-up": true};
        } else return {};
    };

    PrSortClass = (col: string) => {
        if (this.OrderByPr === col + " desc") {
            return {"fa-solid fa-chevron-down": true};
        } else if (this.OrderByPr === col + " asc") {
            return {"fa-solid fa-chevron-up": true};
        } else return {};
    };

    PoSortClass = (col: string) => {
        if (this.OrderByPo === col + " desc") {
            return {"fa-solid fa-chevron-down": true};
        } else if (this.OrderByPo === col + " asc") {
            return {"fa-solid fa-chevron-up": true};
        } else return {};
    };

    CheckItemsChanged = () => {
        if (this.CheckAllItems) {
            if (this.Items != null && this.Items.length > 0) {
                for (let i = 0; i < this.Items.length; i++) {
                    const itm = this.Items[i];
                    itm.Selected = true;
                }
            }
        } else {
            if (this.Items != null && this.Items.length > 0) {
                for (let i = 0; i < this.Items.length; i++) {
                    const itm = this.Items[i];
                    itm.Selected = false;
                }
            }
        }
    };

    GetSelectedItems = () => this.Items.filter(i => i.Selected);

    SelectedItemsCount = () => {
        return this.Items.filter(i => i.Selected).length;
    };

    CurrentPageResultCount = () => {
        if (this.CurrentSearch.Page == this.CurrentSearch.PageTotal) {
            const mod = this.CurrentSearch.Results % this.ResultCount;
            return mod == 0 ? this.ResultCount : mod;
        } else {
            return this.ResultCount;
        }
    };

    GetSelectedApprovableItems = () => {
        for (let i = 0; i < this.Items.length; i++) {
            const itm = this.Items[i];
            if (itm.Selected && (itm.Canceled == "Yes" || !itm.ApproveVisible)) {
                itm.Selected = false;
            }
        }

        return this.GetSelectedItems();
    };

    /*
    // not currently used
    SelectedCanceledItemsCount = () => {
        return this.Items.filter(i => i.Selected && i.Canceled == "Yes").length;
    }
    */

    GetSelectedCanceledItems = () => {
        for (let i = 0; i < this.Items.length; i++) {
            const itm = this.Items[i];
            if (itm.Selected && itm.Canceled == "No") {
                itm.Selected = false;
            }
        }

        return this.GetSelectedItems();
    };

    GetSelectedItemIDs = () => this.GetSelectedItems().map(i => i.ItemID);

    GetSelectedTypes = () => this.GetSelectedItems().map(i => i.itemType);

    AnySelected = () => this.Items.some(i => i.Selected);

    AnyApprovableItemsSelected = () =>
        this.Items.some(i => i.Selected && (i.Canceled ?? "No") == "No" && i.ApproveVisible);

    AnyCanceledItemsSelected = () => this.Items.some(i => i.Selected && i.Canceled == "Yes");

    GetClass = step => {
        if (step.StepID == this.SelectedStep) {
            return "active";
        }
        return "";
    };

    PageChange = event => {
        this.Page = event;
        this.Refresh();
    };

    RestoreItem = item => {
        this.Loading = true;

        const request = {
            ItemIDs: [item.ItemID],
            Reference: String(item.ItemType)
        };

        this.api.postApiPTPRestore(request).subscribe({
            next: data => {
                data.Messages.forEach(m => this.Success(m));
                data.Errors.forEach(m => this.Error(m));
                this.Refresh();
            },
            error: error => {
                this.Error(`${item.VendorName}: ${error.error.Message}`);
                this.Loading = false;
            }
        });
    };

    RestoreMultipleItems = () => {
        this.CloseModal();
        this.Loading = true;

        const items = this.GetSelectedCanceledItems();

        if (items.length == 0) return;

        const request = {
            ItemIDs: items.map(i => i.ItemID),
            Reference: String(items[0].ItemType)
        };

        this.api.postApiPTPRestore(request).subscribe({
            next: data => {
                data.Messages.forEach(m => this.Success(m));
                data.Errors.forEach(m => this.Error(m));
                this.Refresh();
            },
            error: error => {
                this.Error(error.error.Message);
                this.Loading = false;
            }
        });
    };

    ApprovePR = item => {
        this.Loading = true;

        const items = [item];
        const badItems = [];

        /* Don't allow approving an item if:
            - missing location
            - requires Vendor Name or Vendor Number and is missing either value
        */
        items.forEach(item => {
            const itemName = `#${item.PONumber ? item.PONumber : item.PRID}`;
            const location = item.Location;
            const vendorName = item.VendorName.trim().toLowerCase();
            const vendorNumber = item.VendorNumber.trim();
            let errors = false;

            if (this.RequiresVendorNameAndNumber(item)) {
                if (vendorName === "" || vendorName === "unspecified") {
                    this.Error(`${itemName}: Vendor Name is Required`);
                    errors = true;
                }

                if (vendorNumber === "") {
                    this.Error(`${itemName}: Vendor Number is Required`);
                    errors = true;
                }
            }

            if (location === undefined || location === 0) {
                this.Error(`${itemName}: Location is Required`);
                errors = true;
            }

            if (errors) {
                badItems.push(item);
            }
        });

        badItems.forEach(badItem => {
            for (let i = items.length; i--; ) {
                if (items[i] === badItem) {
                    items.splice(i, 1);
                    break;
                }
            }
        });

        if (items.length == 0) {
            this.Loading = false;
            return;
        }

        const request = {
            ItemIDs: items.map(i => i.ItemID),
            Reference: String(items[0].ItemType)
        };

        this.api.postApiPTPApprove(request).subscribe({
            next: data => {
                data.Messages.forEach(m => this.Success(m));
                data.Errors.forEach(m => this.Error(m));
                this.Refresh();
            },
            error: error => {
                this.Error(error.error.Message);
                this.Loading = false;
            }
        });
    };

    // Note: this is only used by Purchase Orders
    ApprovePO = item => {
        this.Loading = true;

        const itemName = `#${item.PONumber}`;
        let errors = false;

        const location = item.Location;
        const vendorName = item.VendorName.trim().toLowerCase();
        const vendorNumber = item.VendorNumber.trim();

        /* Don't allow approving an item if the PO is missing any of:
            - vendor name
            - vendor number
            - location
        */
        if (vendorName === "" || vendorName === "unspecified") {
            this.Error(`${itemName}: Vendor Name is Required`);
            errors = true;
        }

        if (vendorNumber === "") {
            this.Error(`${itemName}: Vendor Number is Required`);
            errors = true;
        }

        if (location === undefined || location === 0) {
            this.Error(`${itemName}: Location is Required`);
            errors = true;
        }

        if (errors) {
            this.Loading = false;
            return;
        }

        const request = {
            ItemIDs: [item.ItemID],
            Reference: String(item.ItemType)
        };

        this.api.postApiPTPApprove(request).subscribe({
            next: data => {
                data.Messages.forEach(m => this.Success(m));
                data.Errors.forEach(m => this.Error(m));
                this.Refresh();
            },
            error: error => {
                this.Error(`${item.VendorName}: ${error.error.Message}`);
                this.Loading = false;
            }
        });
    };

    ApproveMultipleItems = () => {
        this.CloseModal();
        this.Loading = true;

        const items = this.GetSelectedApprovableItems();
        const badItems = [];

        /* Don't allow approving an item if:
            - missing location
            - requires Vendor Name or Vendor Number and is missing either value
        */
        items.forEach(item => {
            const itemName = `#${item.PONumber ? item.PONumber : item.PRID}`;
            const location = item.Location;
            const vendorName = item.VendorName.trim().toLowerCase();
            const vendorNumber = item.VendorNumber.trim();
            let errors = false;

            if (this.RequiresVendorNameAndNumber(item)) {
                if (vendorName === "" || vendorName === "unspecified") {
                    this.Error(`${itemName}: Vendor Name is Required`);
                    errors = true;
                }

                if (vendorNumber === "") {
                    this.Error(`${itemName}: Vendor Number is Required`);
                    errors = true;
                }
            }

            if (location === undefined || location === 0) {
                this.Error(`${itemName}: Location is Required`);
                errors = true;
            }

            if (errors) {
                badItems.push(item);
            }
        });

        badItems.forEach(badItem => {
            for (let i = items.length; i--; ) {
                if (items[i] === badItem) {
                    items.splice(i, 1);
                    break;
                }
            }
        });

        if (items.length == 0) {
            this.Loading = false;
            return;
        }

        const request = {
            ItemIDs: items.map(i => i.ItemID),
            Reference: String(items[0].ItemType)
        };

        this.api.postApiPTPApprove(request).subscribe({
            next: data => {
                data.Messages.forEach(m => this.Success(m));
                data.Errors.forEach(m => this.Error(m));
                this.Refresh();
            },
            error: error => {
                this.Error(error.error.Message);
                this.Loading = false;
            }
        });
    };

    // called when a single item is denied
    DenyItem = (item, template) => {
        this.DenyRequest.DenyNotes = "";
        this.DenyRequest.DenyID = item.ItemID;
        this.DenyRequest.DenyType = item.ItemType;
        this.modal.open(template, this.ModalOptions);
    };

    DoDenyItem = () => {
        this.CloseModal();
        this.Loading = true;

        const request = {
            ItemIDs: [this.DenyRequest.DenyID],
            Reference: String(this.DenyRequest.DenyType),
            Reference2: this.DenyRequest.DenyNotes
        };

        this.api.postApiPTPDeny(request).subscribe({
            next: data => {
                data.Messages.forEach(m => this.Success(m));

                this.DenyRequest.DenyNotes = "";
                this.DenyRequest.DenyID = 0;
                this.DenyRequest.DenyType = 0;
                this.CheckAllItems = false;

                this.Refresh();
            },
            error: error => {
                this.Error(error.error.Message);
                this.Loading = false;
            }
        });
    };

    DoApplyCheckNumber = () => {
        this.CloseModal();
        this.Loading = true;

        const searchObject = {
            ItemIDs: this.GetSelectedItemIDs(),
            Reference: this.CheckRequest.CheckNumber
        };

        this.api.postApiPTPApplyChecks(searchObject).subscribe({
            next: data => {
                // Clear out the stuff.
                this.CheckRequest.CheckNumber = "";
                // Show success message.
                this.Success(data);
                // Refresh data.
                this.Refresh();
            },
            error: error => {
                this.Error(error.error.Message);
                this.Loading = false;
            }
        });
    };

    DoDeletePO = () => {
        this.CloseModal();
        this.Loading = true;
        const searchObject = {
            ItemIDs: this.GetSelectedItemIDs()
        };

        this.api.postApiPTPDeletePO(searchObject).subscribe({
            next: data => {
                // Clear out the stuff.
                this.CheckAllItems = false;
                // Show success message.
                this.Success(data);
                // Refresh data.
                this.Refresh();
            },
            error: error => {
                this.Error(error.error.Message);
                this.Loading = false;
            }
        });
    };

    // called when a single purchase request item is deleted
    CancelItem = (item, template) => {
        this.CancelRequest.CancelNotes = "";
        this.CancelRequest.CancelID = item.ItemID;
        this.CancelRequest.CancelType = item.ItemType;
        this.modal.open(template, this.ModalOptions);
    };

    // called when a single purchase request item is canceled
    // and before the modal is presented for the cancelation reason
    DeleteItem = (item, template) => {
        this.DeleteRequest.VendorName = item.VendorName;
        this.DeleteRequest.DeleteID = item.ItemID;
        this.DeleteRequest.DeleteType = item.ItemType;
        this.modal.open(template, this.ModalOptions);
    };

    // called when multiple requests are being canceled
    // the notes will apply to every selected request
    CancelMultiple = (item, template) => {
        this.CancelRequest.CancelNotes = "";
        this.CancelRequest.CancelType = item.ItemType;
        this.modal.open(template, this.ModalOptions);
    };

    DoCancelItem = () => {
        this.CloseModal();
        this.Loading = true;

        const request = {
            ItemIDs: [this.CancelRequest.CancelID],
            Reference: String(this.CancelRequest.CancelType),
            Reference2: this.CancelRequest.CancelNotes
        };

        this.api.postApiPTPCancel(request).subscribe({
            next: data => {
                data.Messages.forEach(m => this.Success(m));

                this.CancelRequest.CancelNotes = "";
                this.CancelRequest.CancelID = 0;
                this.CancelRequest.CancelType = 0;
                this.CheckAllItems = false;

                this.Refresh();
            },
            error: error => {
                this.Error(error.error.Message);
                this.Loading = false;
            }
        });
    };

    CancelMultipleRequests = () => {
        this.CloseModal();
        this.Loading = true;

        // get a list of selected approvable items
        // because if they are approvable, they are cancelable
        const items = this.GetSelectedApprovableItems();

        if (items.length == 0) return;

        const request = {
            ItemIDs: items.map(i => i.ItemID),
            Reference: String(this.CancelRequest.CancelType),
            Reference2: this.CancelRequest.CancelNotes
        };

        this.api.postApiPTPCancel(request).subscribe({
            next: data => {
                data.Messages.forEach(m => this.Success(m));

                this.CancelRequest.CancelNotes = "";
                this.CancelRequest.CancelID = 0;
                this.CancelRequest.CancelType = 0;
                this.CheckAllItems = false;

                this.Refresh();
            },
            error: error => {
                this.Error(error.error.Message);
                this.Loading = false;
            }
        });
    };

    DoDeleteRequest = () => {
        this.CloseModal();
        this.Loading = true;

        const request = {
            ItemIDs: [this.DeleteRequest.DeleteID],
            Reference: String(this.DeleteRequest.DeleteType)
        };

        this.api.postApiPTPDeletePR(request).subscribe({
            next: data => {
                this.DeleteRequest.DeleteID = 0;
                this.DeleteRequest.DeleteType = 0;
                this.DeleteRequest.VendorName = "";
                this.CheckAllItems = false;

                this.Success(data);

                this.Refresh();
            },
            error: error => {
                this.Error(error.error.Message);
                this.Loading = false;
            }
        });
    };

    SelectItem = item => {
        const win = window.open(
            "/ptp/Forms?itemId=" + item.ItemID + "&itemType=" + item.ItemType,
            "",
            this.ModalFeatures
        );

        const createItemTimer = setInterval(() => {
            if (win.closed) {
                clearInterval(createItemTimer);
                this.Refresh();
            }
        }, 500);
    };

    // this function takes a PR or PO item an element id,
    // and an optional form name and passes it along to the editor
    // if a formName is given, we load that form first and then
    // if the passed element id matches an element id on that form (or the first one),
    // it will scroll to that element once the form is done loading
    SelectItemAndShow = (item, elementId, formName = "") => {
        const win = window.open(
            `/ptp/Forms?show=${elementId}&itemId=${item.ItemID}&itemType=${item.ItemType}${formName.length > 0 ? "&formName=" + formName : ""}`,
            "",
            this.ModalFeatures
        );

        const createItemNotesTimer = setInterval(() => {
            if (win.closed) {
                clearInterval(createItemNotesTimer);
                this.Refresh();
            }
        }, 500);
    };

    Refresh = () => {
        if (this.CurrentStepObject != null) {
            this.SelectStep(this.CurrentStepObject);
        }
    };

    ClearFilters = () => {
        this.LocationFilter = "";
        this.StepFilter = "";
        this.RequestedByFilter = "";
    };

    GetApproveReport = step => {
        this.pieChartData5 = undefined;
        this.api.getApiPTPGetApproveChart({fromDate: this.FromDateStr, toDate: this.ToDateStr}).subscribe(data => {
            this.Labels5 = data.Labels;
            this.Data5 = data.Data;
            this.pieChartData5 = {labels: data.Labels, datasets: [{data: data.Data}]};
            this.Loading = false;
        });
    };

    GetLocationReport = step => {
        this.pieChartData4 = undefined;
        this.api.getApiPTPGetLocationChart({fromDate: this.FromDateStr, toDate: this.ToDateStr}).subscribe(data => {
            this.Labels4 = data.Labels;
            this.Data4 = data.Data;
            this.pieChartData4 = {labels: data.Labels, datasets: [{data: data.Data}]};
            this.GetApproveReport(step);
        });
    };

    GetVendorReport = step => {
        this.pieChartData3 = undefined;
        this.api.getApiPTPGetVendorChart({fromDate: this.FromDateStr, toDate: this.ToDateStr}).subscribe(data => {
            this.Labels3 = data.Labels;
            this.Data3 = data.Data;
            this.pieChartData3 = {labels: data.Labels, datasets: [{data: data.Data}]};
            this.GetLocationReport(step);
        });
    };

    GetSeriesReport = step => {
        this.barChartData2 = undefined;
        this.api.getApiPTPGetDollarsTimeChart({fromDate: this.FromDateStr, toDate: this.ToDateStr}).subscribe(data => {
            this.Labels2 = data.Labels;
            this.Data2 = data.Data;
            this.Series2 = data.Series;
            this.barChartData2 = {
                labels: data.Labels,
                datasets: [...data.Series.map((x, i) => ({data: data.Data[i], label: x}))]
            };
            this.GetVendorReport(step);
        });
    };

    GetReport = step => {
        this.Labels2 = null;
        this.Series2 = null;
        this.Data3 = null;
        this.Labels3 = null;
        this.Labels = null;
        this.Data = null;
        this.pieChartData = undefined;

        this.api.getApiPTPGetDepartmentChart({fromDate: this.FromDateStr, toDate: this.ToDateStr}).subscribe(data => {
            this.Labels = data.Labels;
            this.Data = data.Data;
            this.pieChartData = {labels: data.Labels, datasets: [{data: data.Data}]};
            this.GetSeriesReport(step);
        });
    };

    ExportSearchResults = () => {
        const step = this.CurrentStepObject;
        // Set vars to necessary default values.
        this.Loading = true;
        const stepId = step.StepID;
        this.SelectedStep = stepId;
        this.CurrentStepObject = step;
        this.SelectedType = step.StepType;
        this.SelectedShowsCreate = step.ShowCreate;
        this.StepName = step.StepName;
        this.CheckAllItems = false;

        if (step.StepType == 2) {
            this.GetReport(step);
            return;
        }

        let search;

        switch (step.StepType) {
            case 0:
                search = this.PRSearch;
                break;
            case 1:
                search = this.POSearch;
                break;
            case 3:
                search = this.DashboardSearch;
                break;
        }

        let searchValue = "";

        if (search.Field) {
            switch (search.Field.SearchType) {
                case 0:
                    searchValue = search.Value;
                    break;
                case 1:
                    // search is already the PR/PO/Dashboard search for this step type
                    searchValue = this.formatSearchDate(search.DateValue);
                    break;
            }
        }

        // gather filters. coerce ids to strings: the api FieldValue is a string and system.text.json rejects raw numbers
        const locationFilterId = String(this.LocationFilter ?? "");
        const stepFilterId = String(this.StepFilter ?? "");
        const requestedByFilterId = String(this.RequestedByFilter ?? "");

        const filters = [];

        if (locationFilterId != "") {
            filters.push({
                FieldName: {
                    SearchOption: "LocationID",
                    SearchValue: "LocationID",
                    SearchType: 0
                },
                FieldValue: locationFilterId
            });
        }

        if (stepFilterId != "") {
            filters.push({
                FieldName: {
                    SearchOption: "StepID",
                    SearchValue: "StepID",
                    SearchType: 0
                },
                FieldValue: stepFilterId
            });
        }

        if (requestedByFilterId != "") {
            filters.push({
                FieldName: {
                    SearchOption: "CreatedBy",
                    SearchValue: "CreatedBy",
                    SearchType: 0
                },
                FieldValue: requestedByFilterId
            });
        }

        const searchObject = {
            FieldName: search.Field,
            FieldValue: searchValue,
            StepID: this.SelectedStep,
            Operator: search.Operator,
            OrderBy: null,
            Filters: filters,
            IncludeCanceled: step.StepType == 0 ? search.ShowCanceled : false
        };

        switch (step.StepType) {
            case 0:
                searchObject.OrderBy = this.OrderByPr ? this.OrderByPr : "PurchaseRequestID desc";
                break;
            case 1:
                searchObject.OrderBy = this.OrderByPo ? this.OrderByPo : "PurchaseOrderID desc";
                break;
            case 3:
                searchObject.OrderBy = this.OrderByDashboard ? this.OrderByDashboard : "Date desc";
                break;
        }

        this.api
            // TODO(FU-11): backend Export returns File() but is typed IActionResult, so orval generated
            // this as a void/JSON method (no Blob responseType in the options shape). Cast to preserve
            // the blob download behavior until the backend declares the file response type.
            .postApiPTPExport(searchObject, {
                headers: {
                    "Cache-Control": "no-cache",
                    Pragma: "no-cache",
                    Expires: "Sat, 01 Jan 2000 00:00:00 GMT"
                },
                responseType: "blob",
                observe: "response"
            } as any)
            .subscribe((response: any) => {
                this.Loading = false;
                Utils.downloadFileContent(response, true);
            });
    };

    SelectStep = (step, newload?) => {
        // Set vars to necessary default values.
        this.Loading = true;
        // clear the previous step's rows immediately so they can't render under the new step's
        // columns while the new results load; the skeleton (driven by Loading) shows meanwhile.
        this.Items = [];
        const stepId = step.StepID;
        this.SelectedStep = stepId;
        this.CurrentStepObject = step;
        this.SelectedType = step.StepType;
        this.SelectedShowsCreate = step.ShowCreate;
        this.StepName = step.StepName;
        this.CheckAllItems = false;

        if (step.StepType == 2) {
            this.GetReport(step);
            return;
        }

        // Set page to 1 if this isn't a refresh.
        if (newload) {
            this.Page = 1;
        }

        let search;

        switch (step.StepType) {
            case 0:
                search = this.PRSearch;
                break;
            case 1:
                search = this.POSearch;
                break;
            case 3:
                search = this.DashboardSearch;
                break;
        }

        let searchValue = "";

        if (search.Field) {
            switch (search.Field.SearchType) {
                case 0:
                    searchValue = search.Value;
                    break;
                case 1:
                    // search is already the PR/PO/Dashboard search for this step type
                    searchValue = this.formatSearchDate(search.DateValue);
                    break;
            }
        }

        // gather filters. coerce ids to strings: the api FieldValue is a string and system.text.json rejects raw numbers
        const locationFilterId = String(this.LocationFilter ?? "");
        const stepFilterId = String(this.StepFilter ?? "");
        const requestedByFilterId = String(this.RequestedByFilter ?? "");

        const filters = [];

        if (locationFilterId != "") {
            filters.push({
                FieldName: {
                    SearchOption: "LocationID",
                    SearchValue: "LocationID",
                    SearchType: 0
                },
                FieldValue: locationFilterId
            });
        }

        if (stepFilterId != "") {
            filters.push({
                FieldName: {
                    SearchOption: "StepID",
                    SearchValue: "StepID",
                    SearchType: 0
                },
                FieldValue: stepFilterId
            });
        }

        if (requestedByFilterId != "") {
            filters.push({
                FieldName: {
                    SearchOption: "CreatedBy",
                    SearchValue: "CreatedBy",
                    SearchType: 0
                },
                FieldValue: requestedByFilterId
            });
        }

        const searchObject = {
            FieldName: search.Field,
            FieldValue: searchValue,
            StepID: this.SelectedStep,
            Operator: search.Operator,
            PageSize: this.ResultCount,
            Page: this.Page,
            OrderBy: null,
            Filters: filters,
            IncludeCanceled:
                (step.StepType == 0 && this.OnFirstPRStep()) || step.StepType == 3 ? search.ShowCanceled : false
        };

        switch (step.StepType) {
            case 0:
                searchObject.OrderBy = this.OrderByPr ? this.OrderByPr : "PurchaseRequestID desc";
                break;
            case 1:
                searchObject.OrderBy = this.OrderByPo ? this.OrderByPo : "PurchaseOrderID desc";
                break;
            case 3:
                searchObject.OrderBy = this.OrderByDashboard ? this.OrderByDashboard : "Date desc";
                break;
        }

        this.Loading = true;

        this.api.postApiPTPSearch(searchObject).subscribe({
            next: data => {
                // Set scope items.
                this.Items = data.Items;

                this.CurrentSearch = {
                    Page: data.Page,
                    PageTotal: data.TotalPages,
                    Results: data.TotalItems
                };

                this.Loading = false;
            },
            error: error => {
                this.Error(error.error);
                this.Loading = false;
            }
        });
    };

    OnFirstPRStep = () => this.StepName === "Request";

    // formats an nz-date-picker value (Date) to the MM/dd/yyyy string the backend date filter expects
    private formatSearchDate = (date: Date): string => {
        if (!(date instanceof Date) || isNaN(date.getTime())) {
            return "";
        }
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        return `${mm}/${dd}/${date.getFullYear()}`;
    };

    ToggleCanceled = () => {
        this.Refresh();
    };

    Search = () => {
        this.Page = 1;
        this.Refresh();
    };

    Clear = () => {
        this.Page = 1;
        const step = this.CurrentStepObject;
        let search;

        switch (step.StepType) {
            case 0:
                search = this.PRSearch;
                this.OrderByPr = undefined;
                break;
            case 1:
                search = this.POSearch;
                this.OrderByPo = undefined;
                break;
            case 3:
                search = this.DashboardSearch;
                this.OrderByDashboard = undefined;
                break;
        }

        search.Field = {};
        search.Operator = "Contains";
        search.Value = null;
        search.DateValue = null;
        this.ClearFilters();
        this.Refresh();
    };

    // Shows a success message.
    Success = message => {
        this.message.success(message);
    };

    HasStep = stepName => {
        return this.Steps.some(s => s.StepName === stepName);
    };

    // Create purchase order: create the record via the API, then open it for editing
    // using the same window/refresh flow as opening an existing item.
    CreatePO = (startStep: string = null) => {
        const stepId = startStep ? this.Steps.find(s => s.StepName === startStep).StepID : this.SelectedStep;

        this.api.postApiPTPCreatePO({stepId}).subscribe({
            next: po => this.SelectItem(po),
            error: error => this.Error(error.error?.Message)
        });
    };

    // Create purchase request: create the record via the API, then open it for editing.
    CreateRequest = (startStep: string = null) => {
        const stepId = startStep ? this.Steps.find(s => s.StepName === startStep).StepID : this.SelectedStep;

        this.api.postApiPTPCreatePORequest({stepId}).subscribe({
            next: pr => this.SelectItem(pr),
            error: error => this.Error(error.error?.Message)
        });
    };

    BuildNotesTable = item => {
        let notes = "No notes.";

        if (item.Notes?.length > 0) {
            notes =
                '<table class="table table-striped" style="margin-bottom:0;"><thead><tr><th>Time</th><th>Author</th><th>Note</th></tr></thead>';

            (item.Notes as any[]).forEach(n => {
                let noteText = n.Note;
                noteText = noteText.length > 30 ? noteText.substring(0, 27) + "..." : noteText;
                notes += `<tr><td>${Utils.FormatDate(new Date(n.NoteTime + "Z"))}</td><td>${n.UserName}</td><td>${noteText}</td></tr>`;
            });

            notes += "</table>";
        }

        return notes;
    };

    BuildTransactionsTable = item => {
        let transactions = "No history.";

        if (item.Transactions?.length > 0 || item.PurchaseRequest?.Transactions?.length > 0) {
            transactions =
                '<table class="table table-striped" style="margin-bottom:0;"><thead><tr><th>Time</th><th>Transaction</th></tr></thead>';

            (item.Transactions as any[]).forEach(h => {
                transactions += `<tr><td>${Utils.FormatDate(new Date(h.HistoryTime + "Z"))}</td><td>${h.Transaction}</td></tr>`;
            });

            // if this is a Purchase Order, add any history from the original request
            if (item.RequestTransactions?.length > 0) {
                (item.RequestTransactions as any[]).forEach(h => {
                    transactions += `<tr><td>${Utils.FormatDate(new Date(h.HistoryTime + "Z"))}</td><td>${h.Transaction}</td></tr>`;
                });
            }

            transactions += "</table>";
        }

        return transactions;
    };

    // check if the Vendor Name and Vendor Number fields are required
    RequiresVendorNameAndNumber = item => {
        // prevent anything other than PO/PRs from being checked
        if (item.ItemType === undefined || item.ItemType === null) {
            return false;
        }

        // POs always require these fields
        if (item.ItemType === 1) {
            return true;
        }

        // it's a purchase request
        if (item.ItemType === 0) {
            // find the "Source Determination" step
            const sourceStep = this.Steps.filter(s => s.StepType === 0 && s.StepName === "Source Determination").pop();

            // couldn't find it
            if (sourceStep === undefined) {
                return false;
            }

            // get the ids of all purchase request steps that are "Source Determination" or after it
            const greaterStepIDs = this.Steps.filter(s => s.StepType === 0 && s.Order >= sourceStep.Order).map(
                s => s.StepID
            );

            if (greaterStepIDs.indexOf(this.CurrentStepObject.StepID) >= 0) {
                return true;
            }
        }

        return false;
    };

    // Shows a error message.
    Error = message => {
        this.message.error(message);
    };

    // Called when the search field changes.
    POFieldChanged = () => {
        // does nothing so far
    };

    // Called when the search field changes.
    PRFieldChanged = () => {
        // does nothing so far
    };

    // Called when the search field changes.
    DashboardFieldChanged = () => {
        // does nothing so far
    };

    HoveredDate: NgbDate | null = null;

    OnDateSelection(date: NgbDate) {
        if (!this.FromDate && !this.ToDate) {
            this.FromDate = date;
        } else if (this.FromDate && !this.ToDate && date.after(this.FromDate)) {
            this.ToDate = date;
        } else {
            this.ToDate = null;
            this.FromDate = date;
        }

        this.GetReport(undefined);
    }

    ResetDates = () => {
        this.FromDate = undefined;
        this.ToDate = undefined;
        this.GetReport(undefined);
    };

    IsHovered(date: NgbDate) {
        return (
            this.FromDate &&
            !this.ToDate &&
            this.HoveredDate &&
            date.after(this.FromDate) &&
            date.before(this.HoveredDate)
        );
    }

    IsInside(date: NgbDate) {
        return this.ToDate && date.after(this.FromDate) && date.before(this.ToDate);
    }

    IsRange(date: NgbDate) {
        return (
            date.equals(this.FromDate) ||
            (this.ToDate && date.equals(this.ToDate)) ||
            this.IsInside(date) ||
            this.IsHovered(date)
        );
    }
}
